import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const CustomerBottomTabs = ({ cartItemCount = 0, favoriteCount = 0 }) => {
  const location = useLocation();

  const tabs = [];
};

export default CustomerBottomTabs;
